import React, { Fragment } from 'react';
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import blogs from '../../api/blogs'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import BlogSingle from '../../components/BlogDetails/BlogDetails';

const BlogDetails = (props) => {
    const { t } = useTranslation();
    const { slug } = useParams()
    const BlogDetails = blogs.find(item => item.slug === slug)
    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                {BlogDetails ? (
                    <BlogSingle />
                ) : (
                    <section className="pt-130 pb-100">
                        <div className="container">
                            <div className="blogListEmpty">
                                <h1>{t('blog.removed_title')}</h1>
                                <p>{t('blog.removed_text')}</p>
                                <Link className="btn btn--styleOne btn--primary mt-4" to="/blog">
                                    {t('blog.back_to_blog')}
                                </Link>
                            </div>
                        </div>
                    </section>
                )}
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetails;
